import React from "react";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class AgentesErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("[AgentesErrorBoundary] Erro capturado:", error);
    console.error("[AgentesErrorBoundary] Component stack:", errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-8 text-center">
          <h2 className="text-xl font-semibold text-destructive mb-4">
            Algo deu errado ao carregar a página de agentes.
          </h2>
          <p className="text-muted-foreground mb-4">
            Erro: {this.state.error?.message || "Desconhecido"}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-primary text-primary-foreground rounded-lg"
          >
            Recarregar página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
